





























import { Prop, Component, Vue } from "vue-property-decorator";
import { resetPassword } from "@/api/user-api";

import AppHeader from "@/components/AppHeaderFake.vue";
import ErrorAlert from "@/components/ErrorAlert.vue";

@Component({
  components: {
    AppHeader,
    ErrorAlert
  }
})
export default class ResetPassword extends Vue {
  @Prop({ required: true }) token!: string;

  password = "";
  errors: string[] = [];

  async submit() {
    try {
      await resetPassword(this.token, this.password);
      this.$router.push("/");
    } catch (errors) {
      this.errors = errors;
    }
  }
}
